import { Git } from "../../engine/Git.ts";
import { Vehicle } from "../../engine/Vehicle.ts";
import { createStrictContext } from "./createStrictContext.ts";

type Model = Git | Vehicle;

export const [ModelContext, useModelContext] = createStrictContext<Model>();

export function useGitContext() {
  const git = useModelContext();

  if (!(git instanceof Git)) {
    throw new Error(`Value in ModelContext is not a git.`);
  }

  return git;
}

export function useVehicleContext() {
  const vehicle = useModelContext();

  if (!(vehicle instanceof Vehicle)) {
    throw new Error(`Value in ModelContext is not a vehicle.`);
  }

  return vehicle;
}
